var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer-wrap"},[_c('the-scroll-top'),_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer__top"},[_c('container',[_c('footer-copyright',{staticClass:"footer__top__copyright",attrs:{"copyright":_vm.items.copyright}}),_c('divider',{staticClass:"footer__top__divider"})],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }